import { Outlet } from "react-router-dom"

import { DocumentAdvancedSearch } from "@/components/documents/DocumentAdvancedSearch"
import { useSession } from "@/store/session"

/**
 * documents.md's `/documents/search` — `DocumentAdvancedSearch`, with
 * document overlays mounted underneath at `:id`/`:id/edit` (see
 * `AppRoutes.tsx`), same "list stays mounted under the modal" contract as
 * the main `/documents` page. Unlike the main list, this page has no tab of
 * its own to fetch — data is only ever loaded per active tab from
 * `/documents` (see `store/documents.ts`), so a direct link straight into
 * `/documents/search/:id` (no prior visit to `/documents`) falls through to
 * `DocumentModal`'s own documented "no document matches" fallback, same as
 * a genuinely nonexistent id.
 */
export function DocumentsSearch() {
  const subject = useSession((s) => s.subject)

  return (
    <>
      <DocumentAdvancedSearch branches={subject?.branches ?? []} />
      <Outlet />
    </>
  )
}
